import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import api from "../../axiosConfig";
import AccountPickerModal from "../pickers/AccountPickerModal";

export default function BxgestiuneCreate() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [showAccPicker, setShowAccPicker] = useState(false);
  const [activeAccField, setActiveAccField] = useState(null);
  const [form, setForm] = useState({
    bxcod: "",
    bxnume: "",
    bxcontimp_id: "",
    bxcontc_imp_id: "",
    bxcontimp_id_v: "",
    bxdepart: 0,
    adresa: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((f) => ({ ...f, [name]: checked }));
    } else if (type === "number") {
      setForm((f) => ({ ...f, [name]: value === "" ? "" : Number(value) }));
    } else {
      setForm((f) => ({ ...f, [name]: value }));
    }
  };

  const handleOpenAccPicker = (fieldName) => {
    setActiveAccField(fieldName);
    setShowAccPicker(true);
  };

  const handlePickAccount = (opt) => {
    if (activeAccField) {
      const code = opt.code || opt.bxcod || opt.bxcont_code || "";
      setForm((f) => ({
        ...f,
        [activeAccField]: opt.id,
        [activeAccField.replace("_id", "_code")]: code,
      }));
    }
    setShowAccPicker(false);
    setActiveAccField(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSubmitting(true);
      const payload = { ...form };

      payload.bxcontimp_id = form.bxcontimp_id ? Number(form.bxcontimp_id) : null;
      payload.bxcontc_imp_id = form.bxcontc_imp_id ? Number(form.bxcontc_imp_id) : null;
      payload.bxcontimp_id_v = form.bxcontimp_id_v ? Number(form.bxcontimp_id_v) : null;
      payload.bxdepart = Number(form.bxdepart) || 0;
      await api.post("/bxgestiune", payload);
      navigate("/bxgestiune");
    } catch (err) {
      alert("Eroare la creare: " + (err.response?.data?.detail || err.message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container className="mt-4">
      <Card className="p-3">
        <h3>Creare Bxgestiune</h3>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cod</Form.Label>
                <Form.Control
                  type="text"
                  name="bxcod"
                  value={form.bxcod ?? ""}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Denumire</Form.Label>
                <Form.Control
                  type="text"
                  name="bxnume"
                  value={form.bxnume ?? ""}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cont stoc</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  placeholder="Click pentru a alege cont..."
                  value={form.bxcontimp_code ? `${form.bxcontimp_code} (ID: ${form.bxcontimp_id})` : (form.bxcontimp_id || "")}
                  onClick={() => handleOpenAccPicker("bxcontimp_id")}
                  style={{ cursor: "pointer", background: "white" }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cont cheltuială</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  placeholder="Click pentru a alege cont..."
                  value={form.bxcontc_imp_code ? `${form.bxcontc_imp_code} (ID: ${form.bxcontc_imp_id})` : (form.bxcontc_imp_id || "")}
                  onClick={() => handleOpenAccPicker("bxcontc_imp_id")}
                  style={{ cursor: "pointer", background: "white" }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Cont venit</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  placeholder="Click pentru a alege cont..."
                  value={form.bxcontimp_code_v ? `${form.bxcontimp_code_v} (ID: ${form.bxcontimp_id_v})` : (form.bxcontimp_id_v || "")}
                  onClick={() => handleOpenAccPicker("bxcontimp_id_v")}
                  style={{ cursor: "pointer", background: "white" }}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Departament</Form.Label>
                <Form.Control
                  type="number"
                  name="bxdepart"
                  value={form.bxdepart ?? 0}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Adresă</Form.Label>
                <Form.Control
                  type="text"
                  name="adresa"
                  value={form.adresa ?? ""}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="text-end">
            <Button type="submit" disabled={submitting}>
              Salvează
            </Button>
          </div>
        </Form>
      </Card>

      <AccountPickerModal
        show={showAccPicker}
        onHide={() => setShowAccPicker(false)}
        onPick={handlePickAccount}
        onSelect={handlePickAccount}
      />
    </Container>
  );
}
